import type { FC } from "react";

type Props = {
  n: number;
  type: string;
  hideValue?: boolean;
};

const TimeBox: FC<Props> = ({ n, type, hideValue }) => {
  if (n <= 0 && type !== "sec" && type !== "min") return null;
  return (
    <div className="size-8 flex flex-col text-white justify-center items-center rounded-lg bg-white/12 shadow-[inset_0_1px_1px_0_rgba(255,255,255,0.25)] backdrop-blur-[22px]">
      <span className="text-md leading-[1] font-bold mt-0">
        {hideValue ? "--" : n < 10 ? `0${n}` : n}
      </span>
      <span className="text-2xs leading-[1] mt-[1px] font-bold text-white/80">
        {type}
      </span>
    </div>
  );
};

export default TimeBox;
